/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  import axios from "axios";
  
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { CANCEL_POLICY } from "../graphql";
  import { VApplication } from "../../../application";
  import {usePolicyId} from "../provider";
  
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  export interface ICancelPolicyMethods extends IPluginMethodMap {
    getCancelPolicyStatus(args: any): Promise<any>;
  }
  
  export interface CancelPolicyProps {
    comments: string;
  }
  
  export class CancelPolicyService implements IAgentPlugin {
    readonly methods: ICancelPolicyMethods;
  
    constructor() {
      this.methods = {
        getCancelPolicyStatus: this.getCancelPolicyStatus.bind(this),
      };
    }
  
    async getCancelPolicyStatus(args: CancelPolicyProps) {
      console.log("args in service", args);
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
      const {policyNumber} = usePolicyId();
      try {
        if (client) {
          const res = await client.mutate({
            mutation: CANCEL_POLICY,
            variables: {
              policyId: policyNumber,
              reason:args?.comments
            },
            fetchPolicy: "no-cache",
          });
          if (res?.data?.cancelPolicy) {
            return res?.data?.cancelPolicy;
          }
        }
      } catch (err: any) {
        // console.log("error in revoke credential", err?.message);
        throw err;
      }
    }
  }
  